import Company from "../pages/company/company";
import Home from "../pages/home/Home";
import Job from "../pages/job/Job";
import Login from "../pages/account/login/Login";
import Register from "../pages/account/register/Register";
import ForgetPassword from "../pages/account/forgetPassword/ForgetPassword";
import config from "@/config";
import IndustrialPark from "@/pages/industrialPark/IndustrialPark";
import DetailJob from "@/pages/job/detailJob/DetailJob";
import DetailIndustry from "@/pages/industrialPark/detail/DetailIndustry";
import NewsPage from "@/pages/news/NewsPage";
import { ResumeIndex } from "@/pages/resume/ResumeIndex";
import RegisterEmployer from "@/pages/account/registerEmployer";
import CandidatePage from "@/pages/cv/Cv";
import { ProfileIndex } from "@/pages/account/profile/ProfileIndex";
import { CreateApplyLists } from "@/pages/account/createApplyLists/CreateApplyLists";
import DetailCompany from "@/pages/company/detail/DetailCompany";
import DetailCV from "@/pages/cv/detailCv/DetailCV";

export const RouterContent = [
  {
    path: config.routes.home,
    element: <Home />,
  },
  {
    path: config.routes.job,
    element: <Job />,
  },
  {
    path: config.routes.company,
    element: <Company />,
  },
  {
    path: config.routes.news,
    element: <NewsPage />,
  },
  {
    path: config.routes.login,
    element: <Login />,
  },
  {
    path: config.routes.registerCandidate,
    element: <Register />,
  },
  {
    path: config.routes.forgotPassword,
    element: <ForgetPassword />,
  },
  {
    path: config.routes.IndustrialPack,
    element: <IndustrialPark />,
  },
  {
    path: config.routes.IndustrialPack + `/:id`,
    element: <DetailIndustry />,
  },
  {
    path: config.routes.job + '/:id',
    element: <DetailJob />,
  },
  {
    path: config.routes.detailCompany + ':id',
    element: <DetailCompany />,
  },
  {
    path: config.routes.resume,
    element: <ResumeIndex />,
  },
  {
    path: config.routes.registerEmployer,
    element: <RegisterEmployer />,
  },
  {
    path: config.routes.cv,
    element: <CandidatePage />
  },
  {
    path: config.routes.detailCv + ':id',
    element:  <DetailCV />,
  },
  {
    path: config.routes.profile,
    element: <ProfileIndex />
  },
  {
    path: config.routes.createApplyLists,
    element: <CreateApplyLists />
  },
];
